export const sidebar = {
  leftWidth: 232,
  rightWidth: 350,
}
